import InboxService from '@/services/InboxService';

const state = {
  accountsData: [],
  loading: false,
  error: null,
};

const mutations = {
  SET_ACCOUNTS_DATA(state, data) {
    state.accountsData = data;
  },
  SET_LOADING(state, status) {
    state.loading = status;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

const actions = {
  async fetchAccountsByProvince({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    try {
      const data = await InboxService.getAccountByProvince();
      commit('SET_ACCOUNTS_DATA', data);
      return data;
    } catch (error) {
      commit('SET_ERROR', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

const getters = {
  accountsData: (state) => state.accountsData,
  isLoading: (state) => state.loading,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};